'use client'

import { Button, Typography } from '@mui/material'

// Types
import type { ButtonProps } from '@/types/components/atoms/button'

const OutlinedButtonAtom = (props: ButtonProps) => {
	// Props
	const { text, type, size, color, startIcon, endIcon, loading, disabled, disableRipple, onClick, onDoubleClick, onTouchStart, onTouchEnd, sx, children } = props

	return (
		<Button
			type={type}
			variant="outlined"
			size={size}
			color={color}
			startIcon={startIcon}
			endIcon={endIcon}
			loading={loading}
			disabled={disabled}
			disableElevation
			disableRipple={disableRipple}
			disableTouchRipple={disableRipple}
			onClick={onClick}
			onDoubleClick={onDoubleClick}
			onTouchStart={onTouchStart}
			onTouchEnd={onTouchEnd}
			sx={{
				minWidth: 'auto',
				textTransform: 'inherit',
				...(!text && {
					px: 1,
					'& .MuiButton-startIcon': { mx: 'inherit' }
				}),
				...(disableRipple && { cursor: 'default' }),
				...sx
			}}
		>
			{text && (
				<Typography
					component="span"
					sx={{
						fontSize: 16,
						textOverflow: 'ellipsis',
						textWrap: 'nowrap',
						overflow: 'hidden'
					}}
				>
					{text}
				</Typography>
			)}

			{children}
		</Button>
	)
}

export default OutlinedButtonAtom
